import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getDharmikSankalpanaList = async (data) => {
  return decryptData(
    await axios.get(
      `/getDharmikSankalpanaList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addDharmikSankalpana = async (data) => {
  return decryptData(
    await axios.post(`/addDharmikSankalpana`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getDharmikSankalpanaListById = async (data) => {
  return decryptData(
    await axios.get(
      `/getDharmikSankalpanaListById?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateDharmikSankalpana = async (data) => {
  return decryptData(
    await axios.post(`/updateDharmikSankalpana`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};
